import styled from "styled-components";

export const MenuStyle = styled.ul`
margin: 0px;
padding: 0px;

display: flex;
gap: 3rem;
align-items: center;

box-sizing: border-box;

list-style: none;
`

export const liElement = styled.li`
`